import { Component, OnInit } from '@angular/core';
import { Router, } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthService, SnackbarFactory, ThemeService } from '@shared/public_api';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LanguageService } from '../../shared/services/language.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  hide = true;

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  constructor(
    private router: Router,
    private authService: AuthService,
    private snackBar: SnackbarFactory,
    private dialog: MatDialog,
    private langService: LanguageService,
    public themeService: ThemeService,
  ) {
    langService.removeLanguageFromLocalStorage();
    authService.clearUserInformation();
  }

  ngOnInit() { }

  login() {
    this.authService.authenticate(this.loginForm.value).subscribe({
      next: (_result) => {
        this.router.navigateByUrl('/');
        this.themeService.onThemeChanged(false, this.authService.userSelectedThemeId, this.authService.userIsDarkTheme);
        this.authService.getUserDefLang().subscribe(
          {
            next: (res) => {
              this.langService.storeLanguageInLocalStorage(res.lang);
            }
          }
        )
      },
      error: err => {
        this.snackBar.showButtonSnackbar(err)
      }
    });

  }
  forgotPassword(event: SubmitEvent) {
    event.preventDefault();

    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      data: { username: this.loginForm.get('username').value },
      width: '300px',
    });
  }
}
